export default __webpack_public_path__ + "media/images/backgrounds/mud_splats/splat-4-6413e5172ca5b823d1f45ca27305991b.svg";